<template>
  <div class="info-page">
    <div class="header">
      <img src="@/assets/images/info-bg.png" class="header-bg" />
      <div class="total-amount">
        <span class="amount-label">{{decryptLabel('YzWWRlR/J1h7QulV3BJPMw==')}}</span>
        <span class="amount-value">¥{{userInfo.repayable_amount}}</span>
      </div>
    </div>
    
    <div class="info-card">
      <div class="card-title">
        <span>{{decryptLabel('ZAOFfrtMjkC3AcNU2bXQwQ==')}}</span>
      </div>
      <div class="info-table">
        <div class="table-row">
          <span class="label">{{decryptLabel('s8faAtHNpBt+jsMfqWPF4A==')}}</span>
          <span class="value">{{userInfo.username}}</span>
        </div>
        <div class="table-row">
          <span class="label">{{decryptLabel('taZknczfPRlIXe8nvp2tuA==')}}</span>
          <span class="value">{{userInfo.mobile}}</span>
        </div>
        <div class="table-row">
          <span class="label">{{decryptLabel('tHLRZE5boCh7jWPWAB2F0A==')}}</span>
          <span class="value">{{userInfo.id_num}}</span>
        </div>
        <div class="table-row">
          <span class="label">{{decryptLabel('oyZEO2v/Jzvas0CvRDkPuQ==')}}</span>
          <span class="value">{{userInfo.cardName}}</span>
        </div>
        <div class="table-row">
          <span class="label">{{decryptLabel('Lnh9i2RCfPCcQSJ7ijigOA==')}}</span>
          <span class="value">{{userInfo.card_num}}</span>
        </div>
        <div class="table-row">
          <span class="label">{{decryptLabel('zNcZnxDXbnwSd3fnOTlV9g==')}}</span>
          <span class="value">{{userInfo.loantime}}</span>
        </div>
        <div class="table-row">
          <span class="label">{{decryptLabel('JzGLO1xovrqsmgwt9xxg1g==')}}</span>
          <span class="value">¥{{userInfo.money}}</span>
        </div>
        <div class="table-row">
          <span class="label">{{decryptLabel('fzHTohYZX21uF/Oz978Wxg==')}}</span>
          <span class="value">{{userInfo.repaymenttime}}</span>
        </div>
        <div class="table-row">
          <span class="label">{{decryptLabel('J5j/iPDu0XDNIJ3BNaP2Ag==')}}</span>
          <span class="value red">{{userInfo.overdue_day}}天</span>
        </div>
        <div class="table-row">
          <span class="label">{{decryptLabel('0oZ8vJJFT5SJF9BAU9+xPA==')}}</span>
          <span class="value red">¥{{userInfo.overdue_money}}</span>
        </div>
        <div class="table-row">
          <span class="label">{{decryptLabel('YzWWRlR/J1h7QulV3BJPMw==')}}</span>
          <span class="value orange">¥{{userInfo.repayable_amount}}</span>
        </div>
      </div>
    </div>
    
    <div class="info-actions">
      <button class="action-btn outline" @click="handleButtonTap('contract')">查看合同</button>
      <button class="action-btn primary" @click="handleButtonTap('code')">{{decryptLabel('Fp0XxAdDl0XUGiiIN17d8w==')}}</button>
    </div>
  </div>
</template>

<script>
import { getStorage } from '@/utils/storage'
import { decryptData } from '@/utils/security'

export default {
  data() {
    return {
      userInfo: {
        username: "",
        id_num: "",
        mobile: "13800138111",
        card_num: "",
        repaymenttime: "暂无",
        repaymenttime1: "",
        overdue_day: "0天",
        money: "",
        overdue_money: "0.00",
        repayable_amount: "0.00"
      }
    }
  },
  created() {
    this.loadUserInfo()
  },
  methods: {
    decryptLabel(encryptedLabel) {
      return decryptData(encryptedLabel);
    },
    handleButtonTap(action) {
      this.$router.push(`/${action}`)
    },
    async loadUserInfo() {
      try {
        const userInfo = getStorage('userInfos')
        if (userInfo) {
          this.userInfo = userInfo
        } else {
          const storeUserInfo = this.$store.state.user.userInfo
          if (storeUserInfo) {
            this.userInfo = storeUserInfo
          }
        }
      } catch (error) {
      }
    }
  }
}
</script>

<style scoped>
.info-page {
  padding: 0;
  background: linear-gradient(180deg, #f0fdf4 0%, #f8fafc 100%);
  min-height: 100vh;
  padding-bottom: calc(72px + env(safe-area-inset-bottom));
}

.header {
  position: relative;
  height: 140px;
}

.header-bg {
  width: 100%;
  height: 140px;
  border-radius: 0 0 32px 32px;
  box-shadow: 0 8px 32px rgba(15, 181, 76, 0.18);
}

.total-amount {
  position: absolute;
  top: 70%;
  left: 24%;
  transform: translate(-50%, -50%);
  text-align: left;
  color: #fff;
}

.amount-label {
  font-size: 14px;
  opacity: 0.95;
  display: block;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.amount-value {
  font-size: 32px;
  font-weight: 800;
  display: block;
  margin-top: 6px;
  letter-spacing: 1px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.info-card {
  background: linear-gradient(145deg, #ffffff 0%, #fafafa 100%);
  margin: 60px 14px 0;
  border-radius: 20px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 2;
  border: 1px solid rgba(255, 255, 255, 0.9);
  overflow: hidden;
}

.info-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(to right, #0FB54C, #8DC641);
}

.card-title {
  padding: 20px 20px 16px;
  font-size: 17px;
  font-weight: 800;
  color: #1f2937;
  border-bottom: 1px solid #f1f5f9;
  letter-spacing: 0.4px;
}

.info-table {
  padding: 0 20px;
}

.table-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f1f5f9;
}

.table-row:last-child {
  border-bottom: none;
}

.label {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

.value {
  font-size: 15px;
  color: #1e293b;
  font-weight: 600;
  letter-spacing: 0.2px;
}

.value.red {
  color: #ef4444;
  font-weight: 700;
}

.value.orange {
  color: #0FB54C;
  font-weight: 800;
  font-size: 16px;
}

.info-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  width: 92%;
  margin-left: auto;
  margin-right: auto;
  gap: 12px;
}

.action-btn {
  flex: 1;
  margin: 0;
  border-radius: 14px;
  height: 48px;
  line-height: 48px;
  font-size: 15px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 0.3px;
}

.action-btn:active {
  transform: translateY(2px) scale(0.98);
}

.action-btn.outline {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  color: #475569;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);
}

.action-btn.primary {
  background: linear-gradient(135deg, #0FB54C 0%, #8DC641 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(15, 181, 76, 0.4);
}

.action-btn.primary:active {
  box-shadow: 0 2px 8px rgba(15, 181, 76, 0.45);
}
</style>
